import { Routes, Route } from 'react-router-dom';

import ResourceAccount from 'pages/accounts/resourceAccounts/Index';
import ResourceAccEdit from 'pages/accounts/resourceAccounts/edit/ResourceAccEdit';
import ResourceAccBuilder from 'pages/accounts/resourceAccounts/builder/ResourceAccBuilder';
import ResourceAccCSV from '@/pages/accounts/resourceAccounts/csv';

// import Users from '@/pages/accounts/users/new/Index.jsx';
import Users from 'pages/accounts/users/new/cavell/Index.jsx';
import AddUser from 'pages/accounts/users/new/cavell/add/AddUser.jsx';

// import UserEdit from 'pages/accounts/users/new/UserEdit';
import UserCSV from 'pages/accounts/users/csv';
import CreateCSV from 'pages/accounts/users/csv/CreateCSV';
import RingGroupMembershipCSV from 'pages/accounts/users/csv/RingGroupMembershipCSV';

import Fof from '@/pages/fof';

import path from '@/routes/constants.js';

function ResourceAccountsRoutes() {
    const { EDIT, BUILDER, CSVRESOURCEACCOUNTS } = path;
    return (
        <Routes>
            <Route index element={<ResourceAccount />} />
            <Route path={EDIT} element={<ResourceAccEdit />} />
            <Route path={CSVRESOURCEACCOUNTS} element={<ResourceAccCSV />} />
            <Route path="*" element={<Fof />} />
        </Routes>
    );
}

function UsersRoutes() {
    const { CSVUSERS, CSVUSERCREATE, CSVRINGGROUPMEMBERSHIP, BUILDER, CREATE } =
        path;

    return (
        <Routes>
            <Route index element={<Users />} />
            <Route path={CREATE} element={<AddUser />} />
            <Route path={CSVUSERS} element={<UserCSV />} hidden />
            <Route path={CSVUSERCREATE} element={<CreateCSV />} />
            <Route
                path={CSVRINGGROUPMEMBERSHIP}
                element={<RingGroupMembershipCSV />}
                hidden
            />
            <Route path={BUILDER} element={<ResourceAccBuilder />} />
            <Route path="*" element={<Fof />} />
        </Routes>
    );
}

export { ResourceAccountsRoutes, UsersRoutes };
